import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function CrushingI() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tDate, setTDate] = useState(""); // End date
  const [showData, setShowData] = useState(false);
  const [expandedShift, setExpandedShift] = useState(null); // For toggling details

  const fetchData = async () => {
    if (!tDate) {
      alert("Please select a date.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://U1.hunzagroupofindustries.com.pk/api/Crushing/GetA?AsDate=${tDate} &CompId=1`
      );
      if (!response.ok) throw new Error("Failed to fetch data");
      const result = await response.json();
      setData(result);
      setShowData(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (num) => Intl.NumberFormat().format(num);

  const groupByShift = () => {
    const groupedData = data.reduce((acc, item) => {
      if (!acc[item.RShift]) acc[item.RShift] = [];
      acc[item.RShift].push(item);
      return acc;
    }, {});
    return groupedData;
  };

  const calculateTotalPwt = (shiftData) =>
    shiftData.reduce((sum, item) => sum + item.Pwt, 0);

  const calculateGrandTotal = () =>
    data.reduce((sum, item) => sum + item.Pwt, 0);

  const toggleDetails = (shift) => {
    setExpandedShift(expandedShift === shift ? null : shift);
  };

  return (
    <div>
      <h3 className="text-center mb-4">Crushing Data </h3>

      {/* Date Selection Input */}
      <div className="row mb-4">
        <div className="col-md-6 offset-md-3">
          <label htmlFor="tDate" className="form-label">
            Select Date:
          </label>
          <input
            type="date"
            id="AsDate"
            className="form-control"
            value={tDate}
            onChange={(e) => setTDate(e.target.value)}
          />
          <button
            className="btn btn-primary w-100 mt-3"
            onClick={fetchData}
            disabled={loading}
          >
            {loading ? "Loading..." : "Show Data"}
          </button>
        </div>
      </div>

      {/* Error State */}
      {error && (
        <div className="alert alert-danger text-center mt-4">
          {error}
        </div>
      )}

      {/* Data Summary and Details */}
      {showData && !loading && data.length > 0 && (
        <div className="mt-4">
          {Object.entries(groupByShift()).map(([shift, shiftData]) => {
            const totalPwt = calculateTotalPwt(shiftData);

            return (
              <div key={shift} className="mb-3">
                <div
                  className={`alert ${
                    expandedShift === shift ? "alert-secondary" : "alert-primary"
                  }`}
                  role="button"
                  onClick={() => toggleDetails(shift)}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <strong>Shift {shift}</strong>
                    <span>Total  Weight(tons): {formatNumber(totalPwt)} </span>
                  </div>
                </div>

                {/* Show Details if the shift is expanded */}
                {expandedShift === shift && (
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover table-sm">
                      <thead className="table-dark">
                        <tr>
                          <th>LoadMode</th>
                          <th>Shift</th>
                          <th className="text-end"> Weight (tons)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {shiftData.map((item, index) => (
                          <tr key={index}>
                            <td>{(item.LoadMode)}</td>
                            <td>{item.RShift}</td>
                            <td className="text-end">{formatNumber(item.Pwt)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}

          {/* Grand Total Section */}
          <div className="alert alert-success mt-4">
            <div className="d-flex justify-content-between align-items-center">
              <strong>Grand Total</strong>
              <span>Total  Weight (ton): {formatNumber(calculateGrandTotal())} </span>
            </div>
          </div>
        </div>
      )}

      {/* No Data Available */}
      {showData && !loading && data.length === 0 && (
        <div className="alert alert-warning text-center mt-4">
          No data available for the selected date.
        </div>
      )}
    </div>
  );
}

export default CrushingI;
